export const routes = (prefix) => [
    {
        path: `/${prefix}/vitals`,
        name: `${prefix}.vitals.index`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.vitals.index`,
                PageDescription: "Vitals recording",
            },
        },
    },
];
